module.exports = __webpack_public_path__ + "static/media/2_14.4fa01292.png";